// let CustomActions = {}

Turbo.StreamActions.dispatch_event = function () {
  console.log("dispatch event: ", this.getAttribute('name'));
  this.dispatchEvent(new Event(this.getAttribute('name'), {
      bubbles: true, cancelable: true
    })
  ); // Dispatch the event globally
}

Turbo.StreamActions.close_drawer = function () {
  console.log("close sidebar")
  console.log("IDENTIFIER: ", this.getAttribute('identifier'));
  this.dispatchEvent(new Event("sidebar:close", {
      bubbles: true, cancelable: true
    })
  ); // Dispatch the event globally
}

Turbo.StreamActions.open_modal = function() {
  const identifier = this.getAttribute('identifier') || 'ui-global-modal';
  $(`.${identifier}`).modal('show');
}
Turbo.StreamActions.close_modal = function() {
  const identifier = this.getAttribute('identifier') || 'ui-global-modal';
  $(`.${identifier}`).modal('hide');
}

Turbo.StreamActions.close_native_modal = function() {
  const identifier = this.getAttribute('identifier');
  const modal = document.querySelector(identifier ? `#${identifier}` : 'dialog');
  if (modal) { modal.close() }
}
Turbo.StreamActions.refresh_page = function() {
  Turbo.visit(window.location.href);
}
Turbo.StreamActions.visit = function() {
  const frame = this.getAttribute('frame')
  const action = frame ? 'replace' : this.getAttribute('action');
  Turbo.visit(this.getAttribute('url'), {
    frame: frame,
    action: action
  });
}

Turbo.StreamActions.hard_refresh_frame = function() {
  const frame = document.getElementById(this.getAttribute("target"))
  if (frame && frame.src) {
    frame.src = frame.src // forces reload
  }
}
Turbo.StreamActions.reload_frame = function() {
  const frame = document.getElementById(this.getAttribute("target"))
  if (frame) { frame.reload() }
}

Turbo.StreamActions.click_on = function() {
  const selector = this.getAttribute("selector")
  const element = document.querySelector(selector)
  if (element) { element.click() }
}

// Remove elements after X milliseconds
// <%= turbo_stream.remove_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.remove_later = function() {
  setTimeout(() => {
    this.targetElements.forEach((element) => element.remove())
  }, this.getAttribute("after"))
}

// Resets a form
// <%= turbo_stream.reset_form "new_post"
Turbo.StreamActions.reset_form = function() {
  this.targetElements.forEach((element) => element.reset())
}

// Scrolls an element into view
// <%= turbo_stream.scroll_to "comment_1"
Turbo.StreamActions.scroll_to = function() {
  this.targetElements.forEach((element) => element.scrollIntoView({behavior: 'smooth'}))
}

// export { CustomActions }
